export default __webpack_public_path__ + "static/media/team1.5c2cb369.jpg";